module.exports = __webpack_public_path__ + "static/media/9_4.22b51f82.png";